<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import PageGrid from '../components/pageGrid.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			steps: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content}>
	<PageGrid gridClass="lg:gap-y-20 lg:gap-x-[120px]">
		{#each content.steps as card, index}
			{@const last = index === content.steps.length - 1}
			{@const leftOffset = index % 6 === 0}
			{@const rightOffset = (index - 4) % 6 == 0}

			<div class="col-span-full lg:col-span-4" class:lg:col-start-5={leftOffset || rightOffset}>
				<Blok content={card} stepNumber={index + 1} />
			</div>

			{#if !last}
				<div class="col-span-full flex items-center justify-center py-4 lg:hidden">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="2"
						height="48"
						viewBox="0 0 2 48"
						fill="none"
					>
						<path d="M1 0L0.999998 48" stroke="#927866" />
					</svg>
				</div>
			{/if}
		{/each}
	</PageGrid>
</div>
